
import { defineComponent, PropType } from 'vue'

import { PreTripDetailsTtn } from '@/core/types/tms-graph.types'

export default defineComponent({
    props: {
        ttn: {
            type: Object as PropType<PreTripDetailsTtn>,
            required: true,
        },
    },
})
